import { Wizard } from "@evergis/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { WizardWrapper } from "../../CopyResource/components/Layer/styled";
import { useDialogWizardContext } from "../../DialogComponents/DialogWizard/DialogWizardContext";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { AddProxyServiceStep, ProxyServiceType } from "./types";

export const AddProxyServiceWizardTitle = () => {
  const { t } = useTranslation("dialogs");
  const { step } = useDialogWizardContext();
  const { serviceType } = useAddProxyServiceContext();
  const stepOffset = ![ProxyServiceType.WMS, ProxyServiceType.ArcGIS].includes(serviceType) ? 1 : 0;

  return (
    <WizardWrapper>
      <Wizard
        currentStep={step}
        steps={[
          {
            label: t("addProxyService.selectTypeAndAddress"),
            disabled: false,
          },
          [ProxyServiceType.WMS, ProxyServiceType.ArcGIS].includes(serviceType) && {
            label: t("addProxyService.selectLayer"),
            disabled: step < AddProxyServiceStep.Layers,
          },
          {
            label: t("addProxyService.nameLayer"),
            disabled: step < AddProxyServiceStep.Meta - stepOffset,
          },
          {
            label: t("addProxyService.importFinish"),
            disabled: step < AddProxyServiceStep.Finish - stepOffset,
          },
        ].filter(Boolean)}
      />
    </WizardWrapper>
  );
};
